const signInStatus = {
    Success: 'Success',
    LockedOut: 'LockedOut',
    Fail: 'Fail',
    EmailNotVerified: 'EmailNotVerified',
};

export default signInStatus;
